// IE 2026 09 10 / ODOO-… (заказ Игоря): текст поиска набран не в той раскладке — кандидаты конвертации
// EN ↔ RU (стандартные раскладки ЙЦУКЕН / QWERTY), RU ↔ UK (отличия: ы→і, э→є, ъ→ї, ё→ґ), в том числе
// смешанный текст (латинская часть → кириллица, кириллическая часть → латиница). Пробелы, цифры и прочие
// символы не трогаем. Кандидаты без дублей и без исходного текста; порядок — по вероятности.
const EN_RU = {
    q:'й', w:'ц', e:'у', r:'к', t:'е', y:'н', u:'г', i:'ш', o:'щ', p:'з', '[':'х', ']':'ъ',
    a:'ф', s:'ы', d:'в', f:'а', g:'п', h:'р', j:'о', k:'л', l:'д', ';':'ж', "'":'э',
    z:'я', x:'ч', c:'с', v:'м', b:'и', n:'т', m:'ь', ',':'б', '.':'ю', '`':'ё',
}
const RU_UK = { 'ы':'і', 'э':'є', 'ъ':'ї', 'ё':'ґ' }
const RU_EN = Object.fromEntries(Object.entries(EN_RU).map(([en, ru]) => [ru, en]))
const UK_RU = Object.fromEntries(Object.entries(RU_UK).map(([ru, uk]) => [uk, ru]))

const mapChar = (ch, map) => {
    const low = ch.toLowerCase()
    const m = map[low]
    if (m === undefined) return ch
    return (ch !== low) ? m.toUpperCase() : m
}
const hasLatin = (s) => /[a-z]/i.test(s)
const hasCyr = (s) => /[а-яёіїєґ]/i.test(s)

export function toRu(text) { return String(text).split('').map(ch => mapChar(ch, EN_RU)).join('') }
export function toUk(text) { return toRu(text).split('').map(ch => mapChar(ch, RU_UK)).join('') }
export function toEn(text) { return String(text).split('').map(ch => mapChar(mapChar(ch, UK_RU), RU_EN)).join('') }

export function layoutCandidates(text) {
    const src = String(text ?? '')
    if (!src.trim()) return []
    const out = []
    const add = (s) => { if (s && s !== src && !out.includes(s)) out.push(s) }
    if (hasLatin(src)) { add(toRu(src)); add(toUk(src)) }
    if (hasCyr(src)) add(toEn(src))
    return out
}
